export const carFeeType = "車位費";
export const scooterFeeType = "清潔費";
